import { getAllGameQuery } from 'dataLayer/game'
import GameCard from 'layout/MainLayout/components/GameCard'
import { useEffect, useState, memo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'

function GameContent({ valueSearch, type = '' }) {
	const { t } = useTranslation()
	const [listGameIsHot, setListGameIsHot] = useState([])
	const [listGameIsNotHot, setListGameIsNotHot] = useState([])

	const { data: games } = useQuery(getAllGameQuery())
	const gameIsHot = games?.filter(item => item?.is_hot === 1)
	const gameIsNotHot = games?.filter(item => item?.is_hot !== 1)
	const [listGames, setListGames] = useState([])
	useEffect(() => {
		if (games) {
			setListGameIsHot(gameIsHot)
			setListGameIsNotHot(gameIsNotHot)
			setListGames(games)
		} else {
			setListGames([])
			setListGameIsHot([])
			setListGameIsNotHot([])
		}
	}, [games])
	useEffect(() => {
		let resultSearchGame =
			games &&
			Array.isArray(games) &&
			games.filter(it =>
				it.name.toLowerCase().includes(valueSearch.toLowerCase()),
			)
		let resultSearchIsHot =
			gameIsHot &&
			Array.isArray(gameIsHot) &&
			gameIsHot.filter(it =>
				it.name.toLowerCase().includes(valueSearch.toLowerCase()),
			)
		let resultSearchIsNotHot =
			gameIsHot &&
			Array.isArray(gameIsNotHot) &&
			gameIsNotHot.filter(it =>
				it.name.toLowerCase().includes(valueSearch.toLowerCase()),
			)
		setListGames(resultSearchGame)
		setListGameIsHot(resultSearchIsHot)
		setListGameIsNotHot(resultSearchIsNotHot)
	}, [valueSearch])
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	return (
		<Container fluid>
			<Row>
				{listGameIsHot?.length > 0 || listGameIsNotHot?.length > 0 ? (
					isMobileMD ? (
						<>
							{listGameIsHot && listGameIsHot?.length > 0 && (
								<Col xs={12} lg={6} className="mb-3 mb-lg-0 px-0 px-sm-2">
									<GameCard
										type={type}
										data={listGameIsHot[0] || []}
										isHot={true}
										idGame={listGameIsHot[0].id}
									/>
								</Col>
							)}
							<Col xs={12} lg={6}>
								<Row className="row-cols-2">
									{listGameIsNotHot?.map(item => (
										<Col
											className="gx-1 gx-sm-3 gy-2 gy-sm-3 gy-lg-0 mb-lg-3"
											key={item.id}
										>
											<GameCard
												data={item}
												type={type}
												idGame={item.id}
												isSmall={true}
												padding="py-2 py-sm-3 px-2 px-sm-3"
											/>
										</Col>
									))}
								</Row>
							</Col>
						</>
					) : (
						listGames.map(item => (
							<Col
								style={{ paddingBottom: 20 }}
								xs={6}
								sm={6}
								lg={4}
								className="pe-2 px-0 px-sm-2"
							>
								<GameCard
									key={item.id}
									type={type}
									data={item}
									idGame={item.id}
									isHot={item.is_hot === 1 ? true : false}
									isMedium={true}
									// isSmall={true}
									padding="py-2 py-sm-3 px-2 px-sm-3"
								/>
							</Col>
						))
					)
				) : (
					<div>
						<p style={{ textAlign: 'center' }}>{t('room.list-game-no-data')}</p>
					</div>
				)}
			</Row>
		</Container>
	)
}

export default memo(GameContent)
